import React, { useState } from 'react';

import { Col, Modal, ModalProps, Radio, Row } from 'antd';

import KanbanScheduleForm from '../KanbanScheduleForm';
import KanbanSchedulePortoForm from '../KanbanSchedulePortoForm';
import { isAppPortocar } from '@/index';

interface Props extends ModalProps {
  onCancel: () => void;
  companyIds?: number[];
}

enum ScheduleType {
  Porto = 'PORTO',
  Default = 'DEFAULT',
}

const ScheduleCreateModal: React.FC<Props> = ({ companyIds, ...props }) => {
  const [scheduleType, setScheduleType] = useState<ScheduleType>(
    ScheduleType.Default,
  );

  const handleClose = () => {
    props.onCancel();
    setScheduleType(ScheduleType.Default);
  };

  const scheduleTypeOptions = [
    { label: 'Agendamento Padrão', value: ScheduleType.Default },
    { label: 'Agendamento Porto', value: ScheduleType.Porto },
  ];

  const isScheduleTypeDefault = scheduleType === ScheduleType.Default;

  return (
    <Modal
      {...props}
      width={800}
      title="Criação de Novo Agendamento"
      okText="Salvar"
      destroyOnClose={!props.open}
      onCancel={handleClose}
      footer={null}
    >
      <Row gutter={[24, 24]}>
        {isAppPortocar && (
          <Col>
            <Radio.Group
              options={scheduleTypeOptions}
              buttonStyle="solid"
              optionType="button"
              value={scheduleType}
              onChange={(e) => setScheduleType(e.target.value)}
            />
          </Col>
        )}

        {isScheduleTypeDefault && (
          <Col>
            <KanbanScheduleForm
              companyIds={companyIds}
              onCancel={handleClose}
            />
          </Col>
        )}

        {!isScheduleTypeDefault && (
          <Col>
            <KanbanSchedulePortoForm onCancel={handleClose} />
          </Col>
        )}
      </Row>
    </Modal>
  );
};

export default ScheduleCreateModal;
